import {DateTime} from "luxon";
import CurrencyFormatter from "currency-formatter";

export default class DateAndValue {
  /**
   *
   * @param {string} date
   * @param {Number} value
   * @param {boolean} disabled
   */
  constructor({ date, value, disabled }) {
    this.date = date
    this.value = value
    this.disabled = disabled
  }

  get year() {
    return DateTime.fromISO(this.date).year
  }

  get formattedValue() {
    return CurrencyFormatter.format(this.value, { code: "USD" })
  }
}
